import React, { useEffect } from 'react'
import MainFooter from '../Components/Footer/MainFooter'
import styles from './CustomerSupport.module.css'

const CustomerSupport = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])


    

    return (
        <div>
            <div className={styles.firstPaint} >
                <div className={styles.mainHeader}>
                    <h1>Got an query?</h1>
                    <h2>Contact Us</h2>
                </div>
                <div className={styles.container}>
                    <div className={styles.officeSection}>
                        <div className={styles.officeHeader}>Noida Office</div>
                        <div className={styles.officeAddress}>GT - 08, Sector - 117, Noida, 201307</div>
                        <div className={styles.officeContact}>+91-93194-08406</div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default CustomerSupport